import useReveal from "@/hooks/useReveal";

const clients = [
  { name: "(주)제일화성", sub: "화학/산업" },
  { name: "에코프로비엠", sub: "이차전지 소재" },
  { name: "(주)글로벌", sub: "해상, 육상 특수물류" },
  { name: "(주)한진케미칼", sub: "화학" },
  { name: "인지콘트롤스", sub: "자동차 부품" },
  { name: "세지솔로텍", sub: "자동차 부품" },
  { name: "기장군청", sub: "공공기관" },
  { name: "사하구청", sub: "공공기관" },
  { name: "연제구청", sub: "공공기관" },
  { name: "북구청", sub: "공공기관" },
  { name: "서구청", sub: "공공기관" },
  { name: "부산광역시 교육청", sub: "교육시설" },
  { name: "부산시설공단", sub: "공공기관" },
  { name: "기장군보건소", sub: "공공기관" },
  { name: "한국지역난방공사", sub: "공공기관" },
  { name: "부산경제진흥원", sub: "공공기관" },
  { name: "한국수자원공사", sub: "공공기관" },
];

export default function Clients() {
  const ref = useReveal<HTMLDivElement>();
  const looped = [...clients, ...clients];

  return (
    <section className="relative w-full py-14 md:py-24 lg:py-32 bg-white overflow-hidden">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div ref={ref} className="reveal max-w-3xl mb-8 md:mb-14">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-px bg-point-500"></span>
            <span className="text-point-600 text-xs font-semibold uppercase tracking-[0.3em]">
              Trusted By
            </span>
          </div>
          <h2 className="font-hero text-navy-900 text-3xl md:text-5xl lg:text-6xl leading-tight mb-4 md:mb-6">
            주요 고객사
          </h2>
          <p className="text-neutral-600 text-sm md:text-lg leading-relaxed">
            대기업 공장부터 공공기관·학교까지, 까다로운 시공 기준을 통과한
            현장에서 제이아이앤씨의 실력을 확인할 수 있습니다.
          </p>
        </div>
      </div>

      <div className="relative w-full">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        <div className="flex marquee-track" style={{ width: "max-content" }}>
          {looped.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              className="flex-shrink-0 mx-3 md:mx-6 flex items-center gap-3 md:gap-4 px-6 md:px-10 py-5 md:py-8 bg-neutral-50 border border-neutral-200 rounded-2xl min-w-[200px] md:min-w-[280px] hover:border-point-400 transition-all duration-500 ease-out hover:-translate-y-2"
            >
              <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-navy-900 text-point-400 shrink-0">
                <i className="ri-building-line text-xl md:text-2xl"></i>
              </div>
              <div>
                <div className="font-hero text-base md:text-lg text-navy-900">{c.name}</div>
                <div className="text-xs text-neutral-500 mt-0.5">{c.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}